/**
 * Seeq REST API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 66.223.0-v202611042108-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import type { SeeqRequestOverrides, SeeqErrorData } from '../variables';
import { getRuntime } from '../variables';
import type { AxiosPromise, AxiosError } from 'axios';
import { useMutation, useQuery, type UseMutationOptions, type UseMutationResult, type UseQueryOptions, type UseQueryResult } from '@tanstack/react-query';
import type { AxiosInstance } from 'axios';
import type * as models from '../model/models';

export class sqHierarchiesApiClass {
 
   constructor() {}

  /**
   * @summary Create a new hierarchy from an Item Table. This endpoint is experimental and may change in future releases.
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public createHierarchy(
    body: models.HierarchyInputV1,
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/hierarchies`;
    const urlTemplate = `${baseUrl}/hierarchies`;



    return axiosInstance.request({
      method: 'post',
      url,
      urlTemplate,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.HierarchyOutputV1>;
  }

  /**
   * @summary Get a list of hierarchies. This endpoint is experimental and may change in future releases.
   * @param {number} [offset=0] - The pagination offset, the index of the first item that will be returned in this page of results
   * @param {number} [limit=40] - The pagination limit, the total number of hierarchies that will be returned in this page of results
   * @param {string} [tableDefinitionId] - ID of the table definition that the hierarchy is created from
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public getHierarchies(
    {
      offset,
      limit,
      tableDefinitionId
    } : {
      offset?: number,
      limit?: number,
      tableDefinitionId?: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/hierarchies`;
    const urlTemplate = `${baseUrl}/hierarchies`;

    const queryParams = {
      ['offset']: offset,      ['limit']: limit,      ['tableDefinitionId']: tableDefinitionId
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'get',
      url,
      urlTemplate,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.HierarchyOutputListV1>;
  }

  /**
   * @summary Get a hierarchy by ID. This endpoint is experimental and may change in future releases.
   * @param {string} id - The ID of the hierarchy
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public getHierarchy(
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/hierarchies/${encodeURIComponent(String(id))}`
      .replace('{id}', encodeURIComponent(String(id)));
    const urlTemplate = `${baseUrl}/hierarchies/{id}`;



    return axiosInstance.request({
      method: 'get',
      url,
      urlTemplate,
      ...restOverrides
    }) as AxiosPromise<models.HierarchyOutputV1>;
  }

  /**
   * @summary Find a hierarchy node with path nodes by column id and value. This endpoint is experimental and may change in future releases.
   * @param {string} id - The ID of the hierarchy
   * @param {Array<string>} [columnIds]
   * @param {Array<string>} [columnValues]
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public getHierarchyNode(
    {
      id,
      columnIds,
      columnValues
    } : {
      id: string,
      columnIds?: Array<string>,
      columnValues?: Array<string>
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/hierarchies/${encodeURIComponent(String(id))}/node`
      .replace('{id}', encodeURIComponent(String(id)));
    const urlTemplate = `${baseUrl}/hierarchies/{id}/node`;

    const queryParams = {
      ['columnIds']: columnIds,      ['columnValues']: columnValues
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'get',
      url,
      urlTemplate,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.HierarchyNodeWithPathOutputV1>;
  }

  /**
   * @summary Get nodes in a hierarchy by ID. This endpoint is experimental and may change in future releases.
   * @param {string} id - The ID of the hierarchy
   * @param {Array<string>} [columnIds]
   * @param {Array<string>} [columnValues]
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public getHierarchyNodes(
    {
      id,
      columnIds,
      columnValues
    } : {
      id: string,
      columnIds?: Array<string>,
      columnValues?: Array<string>
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/hierarchies/${encodeURIComponent(String(id))}/nodes`
      .replace('{id}', encodeURIComponent(String(id)));
    const urlTemplate = `${baseUrl}/hierarchies/{id}/nodes`;

    const queryParams = {
      ['columnIds']: columnIds,      ['columnValues']: columnValues
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'get',
      url,
      urlTemplate,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.HierarchyNodeOutputListV1>;
  }

  /**
   * @summary Get the number of Item Finders referencing this hierarchy. This endpoint is experimental and may change in future releases.
   * @param {string} id - The ID of the hierarchy
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public getHierarchyReferenceCount(
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/hierarchies/${encodeURIComponent(String(id))}/referenceCount`
      .replace('{id}', encodeURIComponent(String(id)));
    const urlTemplate = `${baseUrl}/hierarchies/{id}/referenceCount`;



    return axiosInstance.request({
      method: 'get',
      url,
      urlTemplate,
      ...restOverrides
    }) as AxiosPromise<models.HierarchyReferenceCountOutputV1>;
  }

  /**
   * @summary Search for a hierarchy node with path nodes from a scaling table row reference. This endpoint is experimental and may change in future releases.
   * @param {string} scalingTableId - The ID of the Scaling Table being searched
   * @param {string} itemId - The ID of the item being searched for
   * @param {string} rowItemId - The ID of the item that identifies the row of a Scaling Table
   * @param {string} [rowDatumId] - The datum ID that along with &#x27;rowItemId&#x27; identifies the row of a Scaling Table
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public searchHierarchyNode(
    {
      scalingTableId,
      itemId,
      rowItemId,
      rowDatumId
    } : {
      scalingTableId: string,
      itemId: string,
      rowItemId: string,
      rowDatumId?: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (scalingTableId === null || scalingTableId === undefined) {
      throw new Error("'scalingTableId' parameter required");
    }

    if (itemId === null || itemId === undefined) {
      throw new Error("'itemId' parameter required");
    }

    if (rowItemId === null || rowItemId === undefined) {
      throw new Error("'rowItemId' parameter required");
    }


    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/hierarchies/node/search`;
    const urlTemplate = `${baseUrl}/hierarchies/node/search`;

    const queryParams = {
      ['scalingTableId']: scalingTableId,      ['itemId']: itemId,      ['rowItemId']: rowItemId,      ['rowDatumId']: rowDatumId
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'get',
      url,
      urlTemplate,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.HierarchyNodeWithPathOutputV1>;
  }

  /**
   * @summary Update a hierarchy. This endpoint is experimental and may change in future releases.
   * @param {string} id - The Seeq ID for the hierarchy
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public updateHierarchy(
    body: models.HierarchyInputV1,
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/hierarchies/${encodeURIComponent(String(id))}`
      .replace('{id}', encodeURIComponent(String(id)));
    const urlTemplate = `${baseUrl}/hierarchies/{id}`;



    return axiosInstance.request({
      method: 'post',
      url,
      urlTemplate,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.HierarchyOutputV1>;
  }

  /**
   * @summary Validate a hierarchy by ID. This endpoint is experimental and may change in future releases.
   * @param {string} id - The ID of the hierarchy
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public validateHierarchy(
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/hierarchies/${encodeURIComponent(String(id))}/validate`
      .replace('{id}', encodeURIComponent(String(id)));
    const urlTemplate = `${baseUrl}/hierarchies/{id}/validate`;



    return axiosInstance.request({
      method: 'get',
      url,
      urlTemplate,
      ...restOverrides
    }) as AxiosPromise<models.HierarchyValidationOutputV1>;
  }

  /**
   * @summary Validate a hierarchy configuration. This endpoint is experimental and may change in future releases.
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public validateHierarchyInput(
    body: models.HierarchyInputV1,
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/hierarchies/validate`;
    const urlTemplate = `${baseUrl}/hierarchies/validate`;



    return axiosInstance.request({
      method: 'post',
      url,
      urlTemplate,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.HierarchyValidationOutputV1>;
  }

}


export const sqHierarchiesApi = new sqHierarchiesApiClass();

export type sqHierarchiesApiEndpoints = {
  'createHierarchy': {
    method: 'post';
    path: '/hierarchies';
    response: models.HierarchyOutputV1;
  };
  'getHierarchies': {
    method: 'get';
    path: '/hierarchies';
    response: models.HierarchyOutputListV1;
  };
  'getHierarchy': {
    method: 'get';
    path: '/hierarchies/${encodeURIComponent(String(id))}';
    response: models.HierarchyOutputV1;
  };
  'getHierarchyNode': {
    method: 'get';
    path: '/hierarchies/${encodeURIComponent(String(id))}/node';
    response: models.HierarchyNodeWithPathOutputV1;
  };
  'getHierarchyNodes': {
    method: 'get';
    path: '/hierarchies/${encodeURIComponent(String(id))}/nodes';
    response: models.HierarchyNodeOutputListV1;
  };
  'getHierarchyReferenceCount': {
    method: 'get';
    path: '/hierarchies/${encodeURIComponent(String(id))}/referenceCount';
    response: models.HierarchyReferenceCountOutputV1;
  };
  'searchHierarchyNode': {
    method: 'get';
    path: '/hierarchies/node/search';
    response: models.HierarchyNodeWithPathOutputV1;
  };
  'updateHierarchy': {
    method: 'post';
    path: '/hierarchies/${encodeURIComponent(String(id))}';
    response: models.HierarchyOutputV1;
  };
  'validateHierarchy': {
    method: 'get';
    path: '/hierarchies/${encodeURIComponent(String(id))}/validate';
    response: models.HierarchyValidationOutputV1;
  };
  'validateHierarchyInput': {
    method: 'post';
    path: '/hierarchies/validate';
    response: models.HierarchyValidationOutputV1;
  };
};

type ApiCreateHierarchyResponse = models.HierarchyOutputV1;
type ApicreateHierarchyMutationParams = Parameters<typeof sqHierarchiesApi.createHierarchy> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqHierarchiesApi.createHierarchy>;
type ApicreateHierarchyMutationVariables = models.HierarchyInputV1;

export function useApiCreateHierarchyMutation(
  options?: Omit<UseMutationOptions<ApiCreateHierarchyResponse, AxiosError<SeeqErrorData>,
    ApicreateHierarchyMutationVariables>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseMutationResult<ApiCreateHierarchyResponse, AxiosError<SeeqErrorData>,
  ApicreateHierarchyMutationVariables> {
  const { axiosInstance, silent, retryOnConflict, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useMutation({
    mutationFn: (body: ApicreateHierarchyMutationVariables) =>
      sqHierarchiesApi.createHierarchy(body, resolvedOverrides).then((response) => response.data),
    
    
    
    ...mutationOptions,
  });
}
type ApiGetHierarchiesResponse = models.HierarchyOutputListV1;
export function GetHierarchiesQueryKey(
  params: Parameters<typeof sqHierarchiesApi.getHierarchies>[0],
) {
  return ['sqHierarchiesApi', 'getHierarchies', params] as const;
}

export function useApiGetHierarchiesQuery(
  params: Parameters<typeof sqHierarchiesApi.getHierarchies>[0],
  options?: Omit<UseQueryOptions<ApiGetHierarchiesResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseQueryResult<ApiGetHierarchiesResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, retryOnConflict, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useQuery({
    queryKey: GetHierarchiesQueryKey(params),
    queryFn: () =>
      sqHierarchiesApi.getHierarchies(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetHierarchyResponse = models.HierarchyOutputV1;
export function GetHierarchyQueryKey(
  params: Parameters<typeof sqHierarchiesApi.getHierarchy>[0],
) {
  return ['sqHierarchiesApi', 'getHierarchy', params] as const;
}

export function useApiGetHierarchyQuery(
  params: Parameters<typeof sqHierarchiesApi.getHierarchy>[0],
  options?: Omit<UseQueryOptions<ApiGetHierarchyResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseQueryResult<ApiGetHierarchyResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, retryOnConflict, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useQuery({
    queryKey: GetHierarchyQueryKey(params),
    queryFn: () =>
      sqHierarchiesApi.getHierarchy(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetHierarchyNodeResponse = models.HierarchyNodeWithPathOutputV1;
export function GetHierarchyNodeQueryKey(
  params: Parameters<typeof sqHierarchiesApi.getHierarchyNode>[0],
) {
  return ['sqHierarchiesApi', 'getHierarchyNode', params] as const;
}

export function useApiGetHierarchyNodeQuery(
  params: Parameters<typeof sqHierarchiesApi.getHierarchyNode>[0],
  options?: Omit<UseQueryOptions<ApiGetHierarchyNodeResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseQueryResult<ApiGetHierarchyNodeResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, retryOnConflict, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useQuery({
    queryKey: GetHierarchyNodeQueryKey(params),
    queryFn: () =>
      sqHierarchiesApi.getHierarchyNode(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetHierarchyNodesResponse = models.HierarchyNodeOutputListV1;
export function GetHierarchyNodesQueryKey(
  params: Parameters<typeof sqHierarchiesApi.getHierarchyNodes>[0],
) {
  return ['sqHierarchiesApi', 'getHierarchyNodes', params] as const;
}

export function useApiGetHierarchyNodesQuery(
  params: Parameters<typeof sqHierarchiesApi.getHierarchyNodes>[0],
  options?: Omit<UseQueryOptions<ApiGetHierarchyNodesResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseQueryResult<ApiGetHierarchyNodesResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, retryOnConflict, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useQuery({
    queryKey: GetHierarchyNodesQueryKey(params),
    queryFn: () =>
      sqHierarchiesApi.getHierarchyNodes(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetHierarchyReferenceCountResponse = models.HierarchyReferenceCountOutputV1;
export function GetHierarchyReferenceCountQueryKey(
  params: Parameters<typeof sqHierarchiesApi.getHierarchyReferenceCount>[0],
) {
  return ['sqHierarchiesApi', 'getHierarchyReferenceCount', params] as const;
}

export function useApiGetHierarchyReferenceCountQuery(
  params: Parameters<typeof sqHierarchiesApi.getHierarchyReferenceCount>[0],
  options?: Omit<UseQueryOptions<ApiGetHierarchyReferenceCountResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseQueryResult<ApiGetHierarchyReferenceCountResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, retryOnConflict, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useQuery({
    queryKey: GetHierarchyReferenceCountQueryKey(params),
    queryFn: () =>
      sqHierarchiesApi.getHierarchyReferenceCount(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiSearchHierarchyNodeResponse = models.HierarchyNodeWithPathOutputV1;
export function SearchHierarchyNodeQueryKey(
  params: Parameters<typeof sqHierarchiesApi.searchHierarchyNode>[0],
) {
  return ['sqHierarchiesApi', 'searchHierarchyNode', params] as const;
}

export function useApiSearchHierarchyNodeQuery(
  params: Parameters<typeof sqHierarchiesApi.searchHierarchyNode>[0],
  options?: Omit<UseQueryOptions<ApiSearchHierarchyNodeResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseQueryResult<ApiSearchHierarchyNodeResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, retryOnConflict, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useQuery({
    queryKey: SearchHierarchyNodeQueryKey(params),
    queryFn: () =>
      sqHierarchiesApi.searchHierarchyNode(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiUpdateHierarchyResponse = models.HierarchyOutputV1;
type ApiupdateHierarchyMutationParams = Parameters<typeof sqHierarchiesApi.updateHierarchy> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqHierarchiesApi.updateHierarchy>;

export function useApiUpdateHierarchyMutation(
  options?: Omit<UseMutationOptions<ApiUpdateHierarchyResponse, AxiosError<SeeqErrorData>,
    ApiupdateHierarchyMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseMutationResult<ApiUpdateHierarchyResponse, AxiosError<SeeqErrorData>,
  ApiupdateHierarchyMutationParams> {
  const { axiosInstance, silent, retryOnConflict, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useMutation({
    mutationFn: (params: ApiupdateHierarchyMutationParams) =>
      sqHierarchiesApi.updateHierarchy(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiValidateHierarchyResponse = models.HierarchyValidationOutputV1;
export function ValidateHierarchyQueryKey(
  params: Parameters<typeof sqHierarchiesApi.validateHierarchy>[0],
) {
  return ['sqHierarchiesApi', 'validateHierarchy', params] as const;
}

export function useApiValidateHierarchyQuery(
  params: Parameters<typeof sqHierarchiesApi.validateHierarchy>[0],
  options?: Omit<UseQueryOptions<ApiValidateHierarchyResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseQueryResult<ApiValidateHierarchyResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, retryOnConflict, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useQuery({
    queryKey: ValidateHierarchyQueryKey(params),
    queryFn: () =>
      sqHierarchiesApi.validateHierarchy(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiValidateHierarchyInputResponse = models.HierarchyValidationOutputV1;
/** Named request inputs; transport overrides do not identify cached data. */
type ApiValidateHierarchyInputQueryParams = {
  body: models.HierarchyInputV1;
};

/** Omit inputs or individual fields to match multiple cached requests during invalidation. */
type ApiValidateHierarchyInputQueryKeyParams = {
  [K in keyof ApiValidateHierarchyInputQueryParams]?: Partial<ApiValidateHierarchyInputQueryParams[K]>;
};

export function ValidateHierarchyInputQueryKey(input: ApiValidateHierarchyInputQueryKeyParams) {
  return ['sqHierarchiesApi', 'validateHierarchyInput', input] as const;
}

/** A safe, idempotent read transported as POST. The cache stores the unmodified SDK response payload. */
export function useApiValidateHierarchyInputQuery<TData = ApiValidateHierarchyInputResponse>(
  input: ApiValidateHierarchyInputQueryParams,
  options?: Omit<UseQueryOptions<ApiValidateHierarchyInputResponse, AxiosError<SeeqErrorData>, TData>, 'queryKey' | 'queryFn'> & {
    axiosInstance?: AxiosInstance;
    silent?: boolean;
  },
): UseQueryResult<TData, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useQuery({
    queryKey: ValidateHierarchyInputQueryKey(input),
    queryFn: () => sqHierarchiesApi.validateHierarchyInput(
      input.body,
      
      
      requestConfig,
    ).then((response) => response.data),
    ...queryOptions,
  });
}
type ApivalidateHierarchyInputMutationParams = Parameters<typeof sqHierarchiesApi.validateHierarchyInput> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqHierarchiesApi.validateHierarchyInput>;
type ApivalidateHierarchyInputMutationVariables = models.HierarchyInputV1;

export function useApiValidateHierarchyInputMutation(
  options?: Omit<UseMutationOptions<ApiValidateHierarchyInputResponse, AxiosError<SeeqErrorData>,
    ApivalidateHierarchyInputMutationVariables>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseMutationResult<ApiValidateHierarchyInputResponse, AxiosError<SeeqErrorData>,
  ApivalidateHierarchyInputMutationVariables> {
  const { axiosInstance, silent, retryOnConflict, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useMutation({
    mutationFn: (body: ApivalidateHierarchyInputMutationVariables) =>
      sqHierarchiesApi.validateHierarchyInput(body, resolvedOverrides).then((response) => response.data),
    
    
    
    ...mutationOptions,
  });
}
